import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { AdminInvoiceRoute } from '@/modules/invoice/routes/admin-invoice.route'
import { InvoiceRequestModel } from '@/modules/invoice/models/invoice-request.model'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'

@vservice()
export class AdminInvoiceService {
  constructor(
    private readonly routes: AdminInvoiceRoute
  ) {
  }

  store(data: InvoiceRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data,
      { preserveState: true }
    )
  }

  update(id: number, data: InvoiceRequestModel) {
    return Inertia.put(
      this.routes.update(id),
      data,
      { preserveState: true }
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.routes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف فاکتور',
        message: 'آیا از حذف فاکتور اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }

}